
import "babel-polyfill";
import {addCsrfTokenInterceptor} from "~/axios";
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger'
import Cookies from 'js-cookie';
import { Provider } from 'react-redux';
import {routerForBrowser} from 'redux-little-router';

import App from './ui/App/App';
import { AppContainer, } from 'react-hot-loader';
// import { overrideComponentTypeChecker } from 'react-toolbox';
import { createReduce } from "./reducers/reduce";
import initialState from './data/initialState';
import { saveStore } from "./globalStore";
import routeDispatcher from '~/navigation/routeDispatcher';
import routes from '~/navigation/routes';
import { authenticate } from '~/rx/authenticate';
import { actionLogMiddleware } from './actionLogMiddleware';

import "~/ui/connectedRenderHTML";
import locationStateMiddleware from "./navigation/locationStateMiddleware";

const router = routerForBrowser({ routes });
const isProduction = process.env.NODE_ENV === 'production';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const devMiddlewares = !isProduction || new URL(window.location.href).searchParams.get("LOGGER") === "1"
? [applyMiddleware(createLogger({ collapsed: true }))]
: [];

let middlewares = [
    applyMiddleware(thunk),
    applyMiddleware(locationStateMiddleware),
    applyMiddleware(actionLogMiddleware),
    router.enhancer,
    applyMiddleware(router.middleware),
    applyMiddleware(routeDispatcher),
    ...devMiddlewares
];

const initRedux = () => {
    const store = createStore(
        createReduce({ router: router.reducer }),
        initialState,
        composeEnhancers(...middlewares)
    );

    saveStore(store);

    return store;
};

const store = initRedux();

// store.subscribe(() => syncTitle(store.getState));

const attemptAuth = async () => {
    const token = !!Cookies.get('accessToken') || !!Cookies.get('refreshToken');

    if(!token) {
        return null;
    }

    return await store.dispatch(authenticate({token}));
};

const initApp = async () => {
    let auth = await attemptAuth();

/*
    if(auth && auth.success) {
        const initialLocation = store.getState().router;

        if (initialLocation) {
            store.dispatch(initializeCurrentLocation(initialLocation));
        }
    } else if(auth && !auth.success) {

    }*/
};

const render = (rootEl) => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <App modelId="init" />
            </Provider>
        </AppContainer>,
        rootEl
    );
};

if (!isProduction) {
    // overrideComponentTypeChecker((classType, reactElement) => (
    //     reactElement && (
    //         reactElement.type === classType
    //         || reactElement.type.name === classType.displayName
    //     )
    // ));
    if (module.hot) {
        module.hot.accept('./ui/App/App', () => render(document.getElementById('app')));
    }
}

initApp().then(() => {
    console.log('initialized app');

    render(document.getElementById('app'));
});